import boletaApi from "./boletaApi";

export const sendprofileImage = async (file, employeeData) => {
  const formData = new FormData();
  formData.append("profileImage", file);
  formData.append("afiliado", JSON.stringify(employeeData));

  try {
    return await boletaApi.post("/uploadPhotoAfiliado", formData);
  } catch (error) {
    const { response } = error;
    return response;
  }
};
